import Entity from './entity'

export default class TantentSelect extends Entity<number>{
    
    token: string;
    Note: string;
    isLimit: string;
    isAvailable: string;
    isLoginInvalid: string;
    isRevival: string;
    isEffective: string;
    configurationName: string;
    configurationParameter: string;
    keyword: string;
    

}